import {
	TOGGLE_AUTHENTICATE_MODAL,
} from "../app/ActionTypes";

export function toggleAuthenticateModal() {
	return {
		type: TOGGLE_AUTHENTICATE_MODAL
	};
}



// WEBPACK FOOTER //
// ./src/js/authenticate/authenticateActions.js